import {ChangeDetectorRef, Component, OnInit} from '@angular/core';
import {TemplateComponent} from "../template/template.component";
import {BaseListComponent} from "../base-list/base-list.component";
import {EFilterType, ITableConfig} from "../../../interface/table.config";
import {CrudService} from "../service/crud.service";
import {NgIf} from "@angular/common";
import {Router} from "@angular/router";
import {CrudListModel} from "../../../model/crud-list.model";
import {listFromMap, valueFromList} from "../../../helper/list.helper";
import {ECrudFilterType} from "../../../interface/crud.filter-type.enum";

@Component({
  selector: 'app-manager',
  standalone: true,
  imports: [
    TemplateComponent,
    BaseListComponent,
    NgIf
  ],
  templateUrl: './manager.component.html',
  styleUrl: './manager.component.scss'
})
export class ManagerComponent extends CrudListModel implements OnInit {

  override editLink = '/dashboard/manager-edit/';
  override addLink = '/dashboard/manager-create';

  roleList: Record<string, string> = {};

  roleMap: {value: string, label: string}[] = [];
  blockedMap: {value: string, label: string}[] = [
    {value: 'true', label: 'Yes'},
    {value: 'false', label: 'No'},
  ];

  constructor(crudService: CrudService,
              protected cdr: ChangeDetectorRef,
              router: Router) {

    super(crudService, router);

    this.crudService.setProvider('manager');
  }

  protected tableConfig: ITableConfig = {
    rowClass: (item: any) => {
      if (item.blocked) {
        return 'bg-danger-row';
      }

      return '';
    },
    cells: [
      {
        header: 'id',
        field: 'id',
        sortable: true,
        filterType: EFilterType.TEXT,
        crudFilterType: ECrudFilterType.EXACT,
      },
      {
        header: 'FIO',
        field: 'fio',
        sortable: true,
        filterType: EFilterType.TEXT,
      },
      {
        header: 'Job Title',
        field: 'jobTitle',
        sortable: true,
        filterType: EFilterType.TEXT,
      },
      {
        header: 'Email',
        field: 'nickname',
        sortable: true,
        filterType: EFilterType.TEXT,
      },
      {
        header: 'Blocked',
        field: 'blocked',
        sortable: true,
        filterType: EFilterType.SELECT,
        value: (item) => {
          return item.blocked ? 'Yes' : 'No';
        },
        options: () => this.blockedMap,
        crudFilterType: ECrudFilterType.BOOLEAN,
      },
      {
        header: 'Role',
        field: 'managerRoleId',
        sortable: true,
        filterType: EFilterType.SELECT,
        value: valueFromList(this, 'roleList', 'managerRoleId'),
        options: () => this.roleMap,
        crudFilterType: ECrudFilterType.EXACT,
      },
    ],
    actions: [
      'edit',
      'delete',
    ]
  };


  ngOnInit() {
    this.update();

    this.crudService.getList('manager-role', 'id', 'name').then(data => {
      this.roleList = data;
      this.roleMap = listFromMap(this.roleList);

      this.cdr.detectChanges();
    });
  }
}
